import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "overview-metrics" }
const _hoisted_2 = { class: "metric-block" }
const _hoisted_3 = { class: "block-hd" }
const _hoisted_4 = { class: "block-title" }
const _hoisted_5 = { class: "handlers-container" }

import useI18nTl from '@/hooks/useI18nTl'
import IconLightning from '@/components/IconLightning.vue'
import { checkMenuShow } from '@/store/tool'
import { ElMessage, ElMessageBox } from 'element-plus'
import { getEvseConnector, evseTriggerConnector, evseUnlockConnector } from '@/api/evses'
import { updateStationSchedule } from '@/api/operation'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { Refresh } from '@element-plus/icons-vue'
import { ConnectorState } from '@/types/types'
import { throttleBtn } from '@/common/tools'
import LinkOrder from '@/components/Links/LinkOrder.vue'


import { watchEffect, defineComponent, ref, defineProps, onMounted, watch, computed } from 'vue'

const __default__ = defineComponent({
  name: 'EvseConnectors',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  station: {
    type: Object,
    default: () => ({ id: '0' }),
  },
  evseid: {
    type: String,
    default: '0',
  },
  connectors: {
    type: [] as Array<any>,
    default: [],
  },
},
  setup(__props) {

const props = __props

const { t } = useI18nTl('Evses')

const { chargingScheduleAlgorithms, getChargingScheduleDesc } = useProtocolEnums()

const smartChargingScheduleAlgorithm = ref()



const isLoadBalance = computed(() => {
  return props.station?.id != '' && props.station?.id != '0' && checkMenuShow('locationLoadUpsert')
})

const handChargingSchedule = async (row: any) => {
  try {
    if (props.station.powerMax == 0 || props.station.currentMax == null) {
      ElMessage.warning(t('Evses.missingMaxLoad'))
      smartChargingScheduleAlgorithm.value = props.station.schedule
      return
    }

    await ElMessageBox.confirm(
      t('Base.confirmSelect') +
        getChargingScheduleDesc(smartChargingScheduleAlgorithm.value) +
        ' ?',
      {
        confirmButtonText: t('Base.confirm'),
        cancelButtonText: t('Base.cancel'),
        confirmButtonClass: 'confirm-danger',
        type: 'warning',
      },
    )
    const params = {
      evseID: props.evseid,
      algorithm: smartChargingScheduleAlgorithm.value,
    }
    await updateStationSchedule({
      id: props.station.id,
      schedule: smartChargingScheduleAlgorithm.value,
    })
    ElMessage.success(t(`Base.opSuccess`))
  } catch (error) {
    console.log(error)
  }
}

const triggerConnector = async (row: any) => {
  try {
    await evseTriggerConnector({ cno: row.cno, evseID: props.evseid })
    ElMessage.success(t('Base.opSuccess'))

    // 使用 setTimeout 在 3 秒后调用 getEvseConnector
    setTimeout(async () => {
      loadDatas()
    }, 3000) // 3000 毫秒 = 3 秒
  } catch (error) {
    console.error(error)
  }
}
const unlockConnector = async (row: any) => {
  await ElMessageBox.confirm(t('Base.confirmOp') + t('Base.unlock') + ' ?', {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })

  try {
    await evseUnlockConnector({ cno: row.cno, evseID: props.evseid })
    ElMessage.success(t('Base.opSuccess'))
  } catch (error) {
    console.error(error)
  }
}

const lockTable = ref(false)
const tableData = ref(props.connectors)

const loadDatas = async () => {
  lockTable.value = true
  try {
    var params = { evseId: props.evseid, stationId: props.station?.id, state: 0 }
    if (isLoadBalance.value) {
      params.state = ConnectorState.CS_Charging
    }
    const { list = [] } = await getEvseConnector(params)
    tableData.value = list
  } catch (error) {
    tableData.value = []
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadDatas)
onMounted(async () => {
  if (props.connectors?.length == 0) {
    await loadDatas()
  } else {
    tableData.value = props.connectors
  }
})

watch(
  () => props.station,
  (val) => {
    if (props.station.id != '' && props.station.id != '0') {
      smartChargingScheduleAlgorithm.value = props.station.schedule
    }
  },
  { immediate: true },
)

watchEffect(() => {
  tableData.value = props.connectors
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('Evses.connector')), 1),
        _createElementVNode("div", _hoisted_5, [
          (_unref(isLoadBalance))
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                modelValue: smartChargingScheduleAlgorithm.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((smartChargingScheduleAlgorithm).value = $event)),
                placeholder: _ctx.$t('Evses.selectSmartCharging'),
                style: {"width":"240px"},
                onChange: handChargingSchedule
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chargingScheduleAlgorithms), ({ value, label }) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: value,
                      label: label,
                      value: value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_tooltip, {
            content: _ctx.$t('Base.refresh'),
            placement: "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                class: "icon-button",
                type: "primary",
                icon: _unref(Refresh),
                onClick: _unref(loadDatasRefreshLimit)
              }, null, 8, ["icon", "onClick"])
            ]),
            _: 1
          }, 8, ["content"])
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: tableData.value,
      ref: "TableCom",
      "row-key": "id"
    }, {
      default: _withCtx(() => [
        (_unref(isLoadBalance))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              prop: "cname",
              "min-width": "60",
              label: _ctx.$t('Evses.cname'),
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: row.id,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.name), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        (!_unref(isLoadBalance))
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              prop: "cno",
              "min-width": "60",
              label: _ctx.$t('Evses.cno'),
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: row.id,
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(row.cno), 1)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "state",
          "min-width": "40",
          label: _ctx.$t('Evses.state')
        }, {
          default: _withCtx(({ row }) => [
            (_openBlock(), _createBlock(IconLightning, {
              state: row.state,
              cno: row.cno,
              key: row.id
            }, null, 8, ["state", "cno"]))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "orderId",
          "min-width": "100",
          label: _ctx.$t('Evses.order')
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(LinkOrder, {
              id: row.orderId,
              name: row.recordId
            }, null, 8, ["id", "name"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "workPower",
          "min-width": "50",
          label: _ctx.$t('Evses.power')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.workPower) + " W ", 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "workVoltage",
          "min-width": "50",
          label: _ctx.$t('Evses.voltage')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.workVoltage) + " V ", 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "workCurrent",
          "min-width": "50",
          label: _ctx.$t('Evses.current')
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.workCurrent) + " A ", 1)
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          prop: "faultedCode",
          "min-width": "50",
          label: _ctx.$t('Evses.faulted')
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_tooltip, {
              effect: "dark",
              content: row.alarmMsg,
              placement: "top"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.alarmCode), 1)
              ]),
              _: 2
            }, 1032, ["content"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('Base.operation'),
          "class-name": "table-operation"
        }, {
          default: _withCtx(({ row }) => [
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (triggerConnector(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'evseTriggerConnector']
            ]),
            _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              size: "small",
              plain: "",
              onClick: ($event: any) => (unlockConnector(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('Base.unlock')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])), [
              [_directive_role, 'evseUnlockConnector']
            ])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"])), [
      [
        _directive_loading,
        lockTable.value,
        void 0,
        { lock: true }
      ]
    ])
  ]))
}
}

})